// extracted by mini-css-extract-plugin
export var button = "PartnerCardMenu-module__button___MZevq";
export var chevronIcon = "PartnerCardMenu-module__chevronIcon___8vB8U";
export var editIcon = "PartnerCardMenu-module__editIcon___21RPd";
export var manageButton = "PartnerCardMenu-module__manageButton___0jp9c";